<template>
<div>
  <!-- select address and bind the property -->
  <div class="col-md-12">
    <div v-if="billingAddresses.length > 0">
      <p class="text-dark font-weight-bolder">Select Billing Address </p>
      <select @change="selectBillingAddress($event)" class="form-control select-radius">
        <template v-for="(row,rindex) in billingAddresses " :key="rindex">
          <option :value="rindex" >
            {{ addressOneLine(row) }}
          </option>
        </template>
      </select>
    </div>
    <div v-else>
      <div class="alert shadow alert-custom alert-outline-2x alert-outline-warning fade show mt-3" role="alert">
          <div class="alert-icon"><i class="flaticon-warning"></i></div>
          <div class="alert-text">
              Add Billing address first in order to add card.
          </div>
      </div>
    </div>
    <form ref="form" id="payment-form">
      <!-- show card container -->
      <div id="card-container"></div>
      <button id="card-button" :disabled="billingAddresses.length == 0" type="button" @click="tokenizeCard($event)">Save Card</button>
    </form>
  </div>

  <!-- show cards lists -->
  <div class="font-weight-bolder font py-3" v-show="addedCustomerSquareCards.length > 0">Your Cards</div>
  <div class="py-3 mx-4" >
    <div v-show="addedCustomerSquareCards.length > 0">
      <template v-for="(squareCard, index) in addedCustomerSquareCards">
          <div class="border row p-1 mt-2" v-if="squareCard.square_card_id" :key="index">
              <div class="col-sm-12 col-md-6 py-2 text-left">
                <span class="fa fa-credit-card"></span>
                <span v-if="squareCard.card_brand">{{ capitalizeString(squareCard.card_brand) }}</span> ************{{ squareCard.card_last_4 }}
                  Exp: {{ squareCard.card_exp_month }} / {{squareCard.card_exp_year}}
              </div>
              <div class="col-sm-12 col-md-6 text-right  " >
                <span class="pr-10" v-if="addedCustomerSquareCards.length != 1">  
                  <a href="javascript:;" class="btn btn-primary btn-sm rounded" v-if="squareCard.default_card == 0"><span v-on:click.stop="setSquareCardAsDefault(squareCard.customer_id, squareCard.square_customer_id,squareCard.square_card_id)"> Make Default </span></a>
                  <span class="btn btn-default btn-sm rounded" v-if="squareCard.default_card != 0">Default</span>
                </span>
                <span>
                  <a href="javascript:;" v-on:click.stop="deleteSquareCustomerCard(squareCard.id)" class="btn btn-danger btn-sm"><span><i class="kt-nav__link-icon flaticon2-trash"></i></span></a>
                </span>
              </div>
          </div>
      </template>
    </div>        
  </div>
</div>
</template>
<script>
    import CustomerAPIService from '@/js/api/customers/customers';
    import { payments } from '@square/web-sdk';
    import { nanoid } from 'nanoid';
    import AddressAPIService from '@/js/api/address/address';
    import Bugsnag from '@bugsnag/js';

    export default {
      props: ['customerId'],
      data(){
        return {
            addedCustomerSquareCards: [],
            card: [],
            token: '',
            square_connect_client_id: import.meta.env.VITE_SQUARE_APPLICATION_ID,
            square_location_id: import.meta.env.VITE_SQUARE_LOCATION_ID,
            deleteSquareDisableSpinner: false,
            spinner : false,
            buttonDisable: false,
            parentmessage: "",
            showBillingAddressModal: false,
            billingZipCode: '',
            cardPostalCode: '',
            billingAddressId: '',
            billingAddresses:[]
        }
      },
      mounted(){
        // get cards against Customer
        this.initializeCard();
        this.customerSquareCards();
      },
      methods: {
        async initializeCard(){
          try {
            // todo: pass from variable
            const squarePayments = await payments(this.square_connect_client_id, "LBR5KA8XT2DMD");
            this.card =  await squarePayments.card();
            this.card.attach('#card-container');
            // getting billing addresses
            AddressAPIService.getBillingAddresses( this.customerId, this.access_token ).then((response) => {
              if(response.data.hasOwnProperty('billingAddresses')){
                  this.billingAddresses = response.data.billingAddresses;
              }
            }).catch((error) => {
                swal.fire("Error Exception!",error, "error");
            });
          } catch (e) {
            console.error(e);
            this.notify("Error!", "Something went wrong, unable to intialize card !", "error");
            Bugsnag.notify(e);
            return;
          }
        },
        selectBillingAddress(event){
          this.billingZipCode = this.billingAddresses[event.target.value].zip_code
          this.billingAddressId = this.billingAddresses[event.target.value].id
        },
        addressOneLine: function (address) {
          // state null handler
          var staTe =  ", " + address.state;
          var stateHandler = ( address.state == null ) ? "" : staTe;
          //phone null handler
          var phoNe =  ", " + address.phone;
          var phoneHandler = ( address.phone  == null ) ? "" : phoNe;

          // for first time
          if(this.billingZipCode == '' || this.billingAddressId == ''){
            this.billingZipCode = address.zip_code;
            this.billingAddressId = address.id;
          }

          if (address.address_2) {
            var addressOneLine =
              address.name +
              ", " +
              address.address +
              ", " +
              address.address_2 +
              ", " +
              address.city +
              ", " +
              address.zip_code +
              ", " +
              address.country
              +
              phoneHandler
              +
              stateHandler;
          } else {
            var addressOneLine =
              address.name +
              ", " +
              address.address +
              ", " +
              address.city +
              ", " +
              address.state +
              ", " +
              address.zip_code +
              ", " +
              address.country
              +
              phoneHandler
              +
              stateHandler;
          }
          return addressOneLine;
        },
        getSquareLocationID: function(){
          CustomerAPIService.getSquareCustomerLocation(this.access_token).then((response) => {
            if (response.data.hasOwnProperty("locationId")) {
              this.squareLocationID = response.data.locationId;
            }
          }).catch((error) => {
              this.notify("Error Exception!", error, "error");
          });
        },
        customerSquareCards: function () {
          CustomerAPIService.getCustomerSquareCards(this.customerId,this.access_token).then((response) => {
            if (response.data.hasOwnProperty("customerSquareCards")) {
              this.addedCustomerSquareCards = response.data.customerSquareCards;
            }else if(response.data.hasOwnProperty("errors")){
              this.notify("Error Exception!", response.data.error, "error");
            }
          }).catch((error) => {
              this.notify("Error Exception!", error, "error");
          });
        },
        saveSquareCard: function () {
          if(this.cardPostalCode && this.cardPostalCode != this.billingZipCode){
            swal.fire("Postal Codes must be same!", " The Postal Code in the selected billing address is different from Card's Postal Code.", "warning");
            this.spinner=false;
            this.buttonDisable=false;
            this.$store.commit('SHOW_LOADER', false);
            return;
          }
          this.spinner = true;
          this.buttonDisable = true;
          this.$store.commit('SHOW_LOADER', true);
          let data = {
            customer_id: this.customerId,
            token: this.token,
            card: this.cardData,
            nanoid: nanoid(),
            billing_address_id: this.billingAddressId
          };
          // Create info.
          CustomerAPIService.createCustomerSquareCards(data, this.access_token)
            .then((response) => {
              if (response.data.hasOwnProperty("success")) {
                this.card.destroy();
                this.customerSquareCards();
                this.spinner=false;
                this.buttonDisable=false;
                swal.fire({
                  title: 'Success!',
                  text: response.data.success,
                  icon: 'success',
                }).then((result) => {
                  this.initializeCard();
                  this.$store.commit('SHOW_LOADER', false);
                });
              } else if (response.data.hasOwnProperty("errors")) {
                  this.card.clear();
                  this.notify("Error Exception!", response.data.error, "error");
                  this.spinner=false;
                  this.buttonDisable=false;
                  this.$store.commit('SHOW_LOADER', false);
              } else if (response.data.hasOwnProperty("error")) {
                  this.card.clear();
                  swal.fire("Error!", response.data.error, "error");
                  this.spinner=false;
                  this.buttonDisable=false;
                  this.$store.commit('SHOW_LOADER', false);
              }
          }).catch((error) => {
              this.spinner=false;
              this.buttonDisable=false;
              this.$store.commit('SHOW_LOADER', false);
              this.notify("Error Exception!", response.data.error, "error");
          });
        },
        async tokenizeCard($event) {
          try{
            $event.preventDefault();
            this.spinner = true;
            this.buttonDisable = true;
            this.$store.commit('SHOW_LOADER', true);
            const tokenResult = await this.card.tokenize();
            if (tokenResult.status == 'OK') {
              this.token = tokenResult.token;
              this.cardData = tokenResult.details.card;
              tokenResult.details.billing ? this.cardPostalCode = tokenResult.details.billing.postalCode : '';
              this.saveSquareCard();
            } else {
              this.spinner=false;
              this.buttonDisable=false;
              this.$store.commit('SHOW_LOADER', false);
              if (tokenResult.errors.length) {
                let errors_html = "";
                for (let i = 0; i < tokenResult.errors.length; i++) {
                    errors_html += '<li>' + tokenResult.errors[i].message + '</li>';
                }
                this.notify('Error!', errors_html,'error');
              }else
              this.notify("Error!", "Something went wrong, unable to save card !", "error");
            }
          }catch(e){
            this.spinner=false;
            this.buttonDisable=false;
            this.$store.commit('SHOW_LOADER', false);
            this.notify("Error!", "Something went wrong, unable to save card !", "error");
          }
        },
        setSquareCardAsDefault: function(customer_id, square_customer_id, card_id){
          this.spinner = true;
          this.buttonDisable = true;

          let data = {
              square_customer_id: square_customer_id,
              card_id: card_id,
              customer_id: customer_id
          };

          // Create info.
          this.$store.commit('SHOW_LOADER', true);
            CustomerAPIService.defaultCustomerSquareCards(data, this.access_token)
                .then((response) => {
                if (response.data.hasOwnProperty("success")) {
                    this.customerSquareCards();
                    swal.fire("Success!", response.data.success, "success");
                } else if (response.data.hasOwnProperty("error")) {
                  this.notify("Error Exception!", response.data.error, "error");
                  this.spinner=false;
                  this.buttonDisable=false;
                }
                this.$store.commit('SHOW_LOADER', false);
            }).catch((error) => {
                this.spinner=false;
                this.buttonDisable=false;
                this.$store.commit('SHOW_LOADER', false);
                this.notify("Error Exception!", response.data.error, "error");
            });
        },
        deleteSquareCustomerCard: function(id){
          swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, remove it!'
          }).then((result) => {
            if (result.value) {
              this.deleteSquareDisableSpinner = true;
              this.$store.commit('SHOW_LOADER', true);
              CustomerAPIService.deleteCustomerSquareCards(id, this.access_token)
                .then((response) => {
                  if (response.data.hasOwnProperty("success")) {
                    this.deleteSquareDisableSpinner = false;
                    this.$store.commit('SHOW_LOADER', false);
                    this.customerSquareCards();
                    swal.fire("Success!", response.data.success, "success");
                  } else if (response.data.hasOwnProperty("errors")) {
                    this.deleteSquareDisableSpinner = false;
                    this.$store.commit('SHOW_LOADER', false);
                    this.customerSquareCards();
                    this.notify("Error Exception!", response.data.errors, "error");
                  }
              }).catch((error) => {
                this.deleteSquareDisableSpinner = false;
                this.$store.commit('SHOW_LOADER', false);
                this.notify("Error Exception!", response.data.error, "error");
              });
            }
          });
        }
      }
    }
</script>
<style scoped>
  #card-element{
      border: 1px solid #EBEDF3;
      padding: 5px;
  }
  * {
    box-sizing: border-box;
  }

  body {
    font-family: Arial, sans-serif;
  }

  #payment-form {
    margin-bottom: 60px;
    min-width: 300px;
  }

  .buyer-inputs {
    display: flex;
    gap: 20px;
    justify-content: space-between;
    border: none;
    margin: 0;
    padding: 0;
  }

  #card-container {
    margin-top: 45px;
    /* this height depends on the size of the container element */
    /* We transition from a single row to double row at 485px */
    /* Settting this min-height minimizes the impact of the card form loading */
    min-height: 90px;
  }

  #gift-card-container {
    margin-top: 45px;
    min-height: 90px;
  }

  @media screen and (max-width: 500px) {
    #card-container {
      min-height: 140px;
    }
  }

  #ach-button {
    margin-top: 20px;
  }

  #landing-page-layout {
    width: 80%;
    margin: 150px auto;
    max-width: 1000px;
  }

  #its-working {
    color: #737373;
  }

  #example-container {
    width: 100%;
    border: 1px solid #b3b3b3;
    padding: 48px;
    margin: 32px 0;
    border-radius: 12px;
  }

  #example-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  h3 {
    margin: 0;
  }

  p {
    line-height: 24px;
  }

  label {
    font-size: 12px;
    width: 100%;
  }

  input {
    padding: 12px;
    width: 100%;
    border-radius: 5px;
    border-width: 1px;
    margin-top: 20px;
    font-size: 16px;
    border: 1px solid rgba(0, 0, 0, 0.15);
  }

  input:focus {
    border: 1px solid #006aff;
  }
  #card-button {
    font-size: 14px !important;
    width: 85px !important;
    float: right !important;
    padding: 6px !important;
  }

  button {
    color: #ffffff;
    background-color: #006aff;
    border-radius: 5px;
    cursor: pointer;
    border-style: none;
    user-select: none;
    outline: none;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    padding: 12px;
    width: 100%;
    box-shadow: 1px;
  }

  button:active {
    background-color: rgb(0, 85, 204);
  }

  button:disabled {
    background-color: rgba(0, 0, 0, 0.05);
    color: rgba(0, 0, 0, 0.3);
  }

  #payment-status-container {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(0, 0, 0, 0.05);
    box-sizing: border-box;
    border-radius: 50px;
    margin: 0 auto;
    width: 225px;
    height: 48px;
    visibility: hidden;
  }

  #payment-status-container.missing-credentials {
    width: 350px;
  }

  #payment-status-container.is-success:before {
    content: '';
    background-color: #00b23b;
    width: 16px;
    height: 16px;
    margin-right: 16px;
    -webkit-mask: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM11.7071 6.70711C12.0968 6.31744 12.0978 5.68597 11.7093 5.29509C11.3208 4.90422 10.6894 4.90128 10.2973 5.28852L11 6C10.2973 5.28852 10.2973 5.28853 10.2973 5.28856L10.2971 5.28866L10.2967 5.28908L10.2951 5.29071L10.2886 5.29714L10.2632 5.32224L10.166 5.41826L9.81199 5.76861C9.51475 6.06294 9.10795 6.46627 8.66977 6.90213C8.11075 7.4582 7.49643 8.07141 6.99329 8.57908L5.70711 7.29289C5.31658 6.90237 4.68342 6.90237 4.29289 7.29289C3.90237 7.68342 3.90237 8.31658 4.29289 8.70711L6.29289 10.7071C6.68342 11.0976 7.31658 11.0976 7.70711 10.7071L11.7071 6.70711Z' fill='black' fill-opacity='0.9'/%3E%3C/svg%3E");
    mask: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM11.7071 6.70711C12.0968 6.31744 12.0978 5.68597 11.7093 5.29509C11.3208 4.90422 10.6894 4.90128 10.2973 5.28852L11 6C10.2973 5.28852 10.2973 5.28853 10.2973 5.28856L10.2971 5.28866L10.2967 5.28908L10.2951 5.29071L10.2886 5.29714L10.2632 5.32224L10.166 5.41826L9.81199 5.76861C9.51475 6.06294 9.10795 6.46627 8.66977 6.90213C8.11075 7.4582 7.49643 8.07141 6.99329 8.57908L5.70711 7.29289C5.31658 6.90237 4.68342 6.90237 4.29289 7.29289C3.90237 7.68342 3.90237 8.31658 4.29289 8.70711L6.29289 10.7071C6.68342 11.0976 7.31658 11.0976 7.70711 10.7071L11.7071 6.70711Z' fill='black' fill-opacity='0.9'/%3E%3C/svg%3E");
  }

  #payment-status-container.is-success:after {
    content: 'Payment successful';
    font-size: 14px;
    line-height: 16px;
  }

  #payment-status-container.is-failure:before {
    content: '';
    background-color: #cc0023;
    width: 16px;
    height: 16px;
    margin-right: 16px;
    -webkit-mask: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM5.70711 4.29289C5.31658 3.90237 4.68342 3.90237 4.29289 4.29289C3.90237 4.68342 3.90237 5.31658 4.29289 5.70711L6.58579 8L4.29289 10.2929C3.90237 10.6834 3.90237 11.3166 4.29289 11.7071C4.68342 12.0976 5.31658 12.0976 5.70711 11.7071L8 9.41421L10.2929 11.7071C10.6834 12.0976 11.3166 12.0976 11.7071 11.7071C12.0976 11.3166 12.0976 10.6834 11.7071 10.2929L9.41421 8L11.7071 5.70711C12.0976 5.31658 12.0976 4.68342 11.7071 4.29289C11.3166 3.90237 10.6834 3.90237 10.2929 4.29289L8 6.58579L5.70711 4.29289Z' fill='black' fill-opacity='0.9'/%3E%3C/svg%3E%0A");
    mask: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM5.70711 4.29289C5.31658 3.90237 4.68342 3.90237 4.29289 4.29289C3.90237 4.68342 3.90237 5.31658 4.29289 5.70711L6.58579 8L4.29289 10.2929C3.90237 10.6834 3.90237 11.3166 4.29289 11.7071C4.68342 12.0976 5.31658 12.0976 5.70711 11.7071L8 9.41421L10.2929 11.7071C10.6834 12.0976 11.3166 12.0976 11.7071 11.7071C12.0976 11.3166 12.0976 10.6834 11.7071 10.2929L9.41421 8L11.7071 5.70711C12.0976 5.31658 12.0976 4.68342 11.7071 4.29289C11.3166 3.90237 10.6834 3.90237 10.2929 4.29289L8 6.58579L5.70711 4.29289Z' fill='black' fill-opacity='0.9'/%3E%3C/svg%3E%0A");
  }

  #payment-status-container.is-failure:after {
    content: 'Payment failed';
    font-size: 14px;
    line-height: 16px;
  }

  #payment-status-container.missing-credentials:before {
    content: '';
    background-color: #cc0023;
    width: 16px;
    height: 16px;
    margin-right: 16px;
    -webkit-mask: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM5.70711 4.29289C5.31658 3.90237 4.68342 3.90237 4.29289 4.29289C3.90237 4.68342 3.90237 5.31658 4.29289 5.70711L6.58579 8L4.29289 10.2929C3.90237 10.6834 3.90237 11.3166 4.29289 11.7071C4.68342 12.0976 5.31658 12.0976 5.70711 11.7071L8 9.41421L10.2929 11.7071C10.6834 12.0976 11.3166 12.0976 11.7071 11.7071C12.0976 11.3166 12.0976 10.6834 11.7071 10.2929L9.41421 8L11.7071 5.70711C12.0976 5.31658 12.0976 4.68342 11.7071 4.29289C11.3166 3.90237 10.6834 3.90237 10.2929 4.29289L8 6.58579L5.70711 4.29289Z' fill='black' fill-opacity='0.9'/%3E%3C/svg%3E%0A");
    mask: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM5.70711 4.29289C5.31658 3.90237 4.68342 3.90237 4.29289 4.29289C3.90237 4.68342 3.90237 5.31658 4.29289 5.70711L6.58579 8L4.29289 10.2929C3.90237 10.6834 3.90237 11.3166 4.29289 11.7071C4.68342 12.0976 5.31658 12.0976 5.70711 11.7071L8 9.41421L10.2929 11.7071C10.6834 12.0976 11.3166 12.0976 11.7071 11.7071C12.0976 11.3166 12.0976 10.6834 11.7071 10.2929L9.41421 8L11.7071 5.70711C12.0976 5.31658 12.0976 4.68342 11.7071 4.29289C11.3166 3.90237 10.6834 3.90237 10.2929 4.29289L8 6.58579L5.70711 4.29289Z' fill='black' fill-opacity='0.9'/%3E%3C/svg%3E%0A");
  }

  #payment-status-container.missing-credentials:after {
    content: 'applicationId and/or locationId is incorrect';
    font-size: 14px;
    line-height: 16px;
  }
  td{
    text-align: left;
  }
  th{
    text-align: left;
  }
  .select-radius{
    border-radius: 4px ;
    height: 34px;
    padding: 6px 10px;
}
</style>